export default __webpack_public_path__ + "static/media/txt2_pc.ad92f8aa.png";